import { z } from "zod";

export const MAX_FILE_UPLOAD_COUNT = 25 as const;
export const MAX_PRODUCT_FILE_SIZE_BYTES = 5368709120; // 5GB in bytes

export const productFileSchema = z
  .object({
    id: z.uuid(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
    productId: z.uuid(),
    variantId: z.uuid().nullable(),
    optionValueId: z.uuid().nullable(),
    url: z.url(),
    sizeBytes: z.number().int().positive(),
    fileExtension: z.string(),
    name: z.string(),
    label: z.string().nullable(),
  })
  .describe("ProductFile");

export const createProductFileSchema = z
  .object({
    id: z.uuid(),
    productId: z.uuid(),
    variantId: z.uuid().optional(),
    optionValueId: z.uuid().optional(),
    url: z.url(),
    sizeBytes: z.number().int().positive(),
    fileExtension: z.string(),
    name: z.string(),
    label: z.string().optional(),
  })
  .describe("CreateProductFile");

export const updateProductFileSchema = z
  .object({
    name: z.string().optional(),
    label: z.string().nullish(),
  })
  .describe("UpdateProductFile");

export const productFileFiltersSchema = z
  .object({
    productId: z.uuid().optional(),
    variantId: z.uuid().optional(),
    optionValueId: z.uuid().optional(),
    fileExtensions: z.array(z.string()).optional(),
    search: z.string().optional(),
  })
  .describe("ProductFileFilters");

export const generateProductFileSignedUrlSchema = z
  .object({
    projectId: z.uuid(),
    filename: z.string(),
    fileId: z.string(),
    contentType: z.string().optional(),
    contentLength: z.number().int().positive().optional(),
  })
  .describe("GenerateProductFileSignedUrl");

export const productFileUploadResponseSchema = z
  .object({
    signedUrl: z.url(),
    publicUrl: z.url(),
    fileId: z.uuid(),
  })
  .describe("ProductFileUploadResponse");
